
export let baseURL = ""
export let WSSURL = ""
export let isApp=0;//0不是APP打包,1APP打包
switch (process.env.NODE_ENV) {
    case 'development':
        baseURL = "https://dcapi.hongchaoshijie.com"  //开发环境url
        //  baseURL = "http://127.0.0.1:8000"  //开发环境url
        WSSURL = "dcapi.hongchaoshijie.com:8989"
        break
    case 'production':
        baseURL = "https://dcapi.hongchaoshijie.com"
        WSSURL = "dcapi.hongchaoshijie.com:8989"
        break
}

export default {
    isApp,
    baseURL,
    WSSURL
}



// WEBPACK FOOTER //
// ./src/assets/js/baseURL.js